const API_URL = process.env.REACT_APP_API_URL;

export async function authFetch(url, options = {}) {
  const token = localStorage.getItem("token");

  // Ajouter le token dans les headers
  const headers = {
    "Content-Type": "application/json",
    ...options.headers,
    Authorization: `Bearer ${token}`,
  };

  let response = await fetch(url, { ...options, headers });

  // Si 401 → tenter le refresh
  if (response.status === 401 || response.status === 403) {
    const refreshToken = localStorage.getItem("refreshToken");

    if (!refreshToken) {
      forceLogout();
      return response;
    }

    try {
      const refreshRes = await fetch(`${API_URL}/api/auth/refresh`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ refreshToken }),
      });

      if (refreshRes.ok) {
        const data = await refreshRes.json();

        // Mettre à jour les tokens
        localStorage.setItem("token", data.token);
        localStorage.setItem("refreshToken", data.refreshToken);
        localStorage.setItem("user", JSON.stringify(data));

        // Rejouer la requête originale avec le nouveau token
        const retryHeaders = {
          ...headers,
          Authorization: `Bearer ${data.token}`,
        };
        response = await fetch(url, { ...options, headers: retryHeaders });
      } else {
        // Refresh token expiré ou invalide → déconnexion forcée
        forceLogout();
      }
    } catch (err) {
      console.error("Refresh failed:", err);
      forceLogout();
    }
  }

  return response;
}

function forceLogout() {
  localStorage.removeItem("token");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("user");
  sessionStorage.setItem("redirectMessage", "Your session has expired. Please log in again.");
  window.location.href = "/";
}